function getFileNameFromAWSKey(key) {
    return String(key)
        .split("/")
        .slice(2)
        .join("/");
}

export default getFileNameFromAWSKey;
